module.exports = __webpack_public_path__ + "static/media/externalLink.e2f608be.svg";